import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-microInverter",
  "use": "dv-microInverter-usage",
  "viewBox": "0 0 88.1 60.42",
  "content": "<symbol viewBox=\"0 0 88.1 60.42\" id=\"dv-microInverter\"><title>资源 98</title><g id=\"dv-microInverter_图层_2\" data-name=\"图层 2\"><g id=\"dv-microInverter_图层_1-2\" data-name=\"图层 1\"><path d=\"M85.49,20.47h-4V7.07a2.61,2.61,0,0,0-2.61-2.61H62.79V2.61A2.61,2.61,0,0,0,60.18,0h-32a2.61,2.61,0,0,0-2.61,2.61V4.47H9.43A2.61,2.61,0,0,0,6.83,7.07v6.58H6.58A6.58,6.58,0,0,0,0,20.22s0,.09,0,.14V34.24c0,.08,0,.17,0,.26A6.45,6.45,0,0,0,6.45,41h.4l0,6.58a2.61,2.61,0,0,0,2.61,2.61H23.7a2.61,2.61,0,0,0-2.61,2.61v5.09a2.61,2.61,0,0,0,2.61,2.61H65.14a2.61,2.61,0,0,0,2.61-2.61V52.61A2.61,2.61,0,0,0,65.14,50H79.41a2.61,2.61,0,0,0,2.11-2.49V34.12h4a2.61,2.61,0,0,0,2.61-2.61V23.08A2.61,2.61,0,0,0,85.49,20.47ZM42.81,16h9.43l-7.32,7.82H56.46L38.59,38.22l5.34-9.55-11.79-.25ZM64.1,55.23v1.91H24.66v-.27h0V55.24h0a2.09,2.09,0,0,1,.55-.05H63.53a2.21,2.21,0,0,1,.57.05Zm17-25.09v-6h2v6h-2Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-microInverter.svg
// module id = 9PNy
// module chunks = 264